module.exports = __webpack_public_path__ + "static/media/README.28ab07e2.md";